import { render, staticRenderFns } from "./SingleColumnLayout.vue?vue&type=template&id=7b899c64&"
import script from "./SingleColumnLayout.vue?vue&type=script&lang=ts&"
export * from "./SingleColumnLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports